import client from './client';

/* export const getDocumentationSections = async () => {
  try {
    //const response = await client.get("/api/documentation-sections?populate=*");
    //const response = await client.get("/api/documentation-sections?populate=image");
    const response = await client.get("/api/documentation-sections?populate[image]=*&populate[documentation_section]=*");
      //"/api/documentation-sections?populate[image]=true&populate[documentation_section][fields]=title,slug&populate[documentation_section][populate]=content"

    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("API Error:", error.response.data);
    } else if (error.request) {
      console.error("No response from server:", error.request);
    } else {
      console.error("Error configurando la solicitud:", error.message);
    }
    throw error;
  }
}; */

/* export const getDocumentationSections = async () => {
  try {
    const response = await client.get(
      "/api/documentation-sections?populate[image]=true"
    );


    if (!response.data || !response.data.data) {
      throw new Error("Estructura de datos inválida en la API");
    }

    //console.log(response.data.data)

    // Transformamos los datos para anidar subsecciones bajo sus secciones principales
    const sections = response.data.data.map(section => ({
      id: section.id,
      title: section.title || "Sin título",
      slug: section.slug || "",
      content: section.content || [],
      image: section.image ? section.image.url : null,
      //documentation_section: section.documentation_section || null
      subsections: section.attributes.documentation_section?.data.map(sub => ({
        id: sub.id,
        title: sub.attributes.title,
        slug: sub.attributes.slug
      })) || [] // Si no tiene subsecciones, dejar un array vacío
    }));

    return sections;
  } catch (error) {
    console.error("Error cargando documentación", error);
    throw error;
  }
}; */

export const getDocumentationSections = async () => {
  try {
    const response = await client.get("/api/documentation-sections?populate=image");

//"/api/homepage?populate[solutions_section][populate][solutions_section_items][populate]=image"

    if (!response.data || !response.data.data) {
      throw new Error("Estructura de datos inválida en la API");
    }

    let sections = response.data.data.map(section => ({
      id: section.id,
      title: section.title || "Sin título",
      slug: section.slug || "",
      content: section.content || [],
      image: section.image ? section.image : null,
      gallery: section.gallery || [],
      contentJson: section.contentJson
        ? section.contentJson.map((item) => ({
            content: item.content || "",
            json: item.json || {},
            image: item.image ? item.image : null,
          }))
        : [],
    }));

    // Ordenar alfabéticamente por título dejando "general-overview" primero
    sections = sections.sort((a, b) => {
      if (a.slug === "general-overview") return -1; // Siempre primero
      if (b.slug === "general-overview") return 1;
      return a.title.localeCompare(b.title); // Orden alfabético
    });

    return sections;
  } catch (error) {
    console.error("Error cargando documentación", error);
    throw error;
  }
};



export const getAPIDetails = async (slug) => {
  try {
    const response = await client.get(`/api/api-references?filters[slug][$eq]=${slug}&populate=*`);
    return response.data.data[0];
  } catch (error) {
    console.error("Error obteniendo detalles de la API:", error);
    throw error;
  }
};
